const SK = 'animate-pulse rounded-(--radius-md) bg-[var(--skeleton-base)]';

/**
 * Full-screen loading skeleton for the mobile agenda layout. Mimics the
 * touch-first header (month + navigation + view tabs) and a list of event
 * placeholder rows.
 *
 * @returns The mobile agenda skeleton element.
 */
export function AgendaMobileSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-col bg-[var(--surface-primary)]">
      {/* Header: month label + settings + nav arrows */}
      <div className="shrink-0 px-(--space-4) pt-(--space-3) pb-(--space-2)">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-(--space-2)">
            <div className={`${SK} h-5 w-5`} />
            <div className={`${SK} h-5 w-24`} />
          </div>
          <div className="flex items-center gap-(--space-3)">
            <div className={`${SK} h-5 w-5`} />
            <div className={`${SK} h-5 w-5`} />
            <div className={`${SK} h-5 w-5`} />
          </div>
        </div>
      </div>

      {/* View tabs */}
      <div className="shrink-0 px-(--space-4) pb-(--space-3)">
        <div
          className="flex gap-(--space-1) rounded-(--radius-lg) bg-[var(--surface-secondary)] p-(--space-1)"
        >
          <div className={`${SK} h-9 flex-1`} />
          <div className={`${SK} h-9 flex-1`} />
          <div className={`${SK} h-9 flex-1`} />
          <div className={`${SK} h-9 flex-1`} />
        </div>
      </div>

      {/* Content: event list placeholder rows */}
      <div className="flex-1 overflow-hidden px-(--space-4) pt-(--space-2)">
        {Array.from({ length: 3 }).map((_, g) => (
          <div key={g} className="mb-(--space-5)">
            {/* Day header */}
            <div className="mb-(--space-2) flex items-center gap-(--space-2)">
              <div className={`${SK} h-10 w-10 rounded-full`} />
              <div className="flex flex-col gap-(--space-1)">
                <div className={`${SK} h-3.5 w-20`} />
                <div className={`${SK} h-3 w-28`} />
              </div>
            </div>
            {/* Event cards */}
            <div className="ml-(--space-5) flex flex-col gap-(--space-2) border-l-2 border-[var(--border-subtle)] pl-(--space-5)">
              {Array.from({ length: 2 }).map((_, c) => (
                <div
                  key={c}
                  className="rounded-(--radius-lg) border border-[var(--border-subtle)] p-(--space-3)"
                  style={{ borderLeftWidth: 4, borderLeftColor: 'var(--surface-tertiary)' }}
                >
                  <div className="flex gap-(--space-3)">
                    <div className="flex shrink-0 flex-col items-center" style={{ minWidth: 48 }}>
                      <div className={`${SK} h-4 w-10`} />
                      <div className={`${SK} mt-(--space-1) h-3 w-6`} />
                    </div>
                    <div className="flex-1">
                      <div className={`${SK} h-4 w-3/4`} />
                      <div className={`${SK} mt-(--space-1) h-3 w-1/2`} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
